/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCellAllBorderNone = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M7 2h4v2H7zM5 2v2H4v1H2V2zm8 0h4v2h-4zm7 2h-1V2h3v3h-2zm2 3v4h-2V7zM4 7v4H2V7zm0 6v4H2v-4zm18 0v4h-2v-4zM4 20v-1H2v3h3v-2zm16 0v-1h2v3h-3v-2zM7 20h4v2H7zm6 0h4v2h-4z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCellAllBorderNone as CellAllBorderNone };
